var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2778 48.9263C56.7403 44.3335 59.5 38.0761 59.5 31.167C59.5 17.0853 48.0817 5.66699 34 5.66699C19.9183 5.66699 8.5 17.0853 8.5 31.167C8.5 38.0761 11.2597 44.3335 15.7222 48.9263C15.7477 48.9532 15.7647 48.983 15.7902 49.0099L15.8737 49.0935C15.9403 49.1615 16.0069 49.2281 16.0749 49.2947L31.9968 65.2166C33.1033 66.323 34.8967 66.323 36.0032 65.2166L51.9251 49.2947C51.9931 49.2281 52.0597 49.1615 52.1262 49.0935L52.2098 49.0099C52.2367 48.983 52.2537 48.9518 52.2778 48.9263Z",
    fill: "url(#paint0_linear_299_60842)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M47.6156 25.8894C47.6156 25.2789 47.2572 24.8779 46.8223 24.5521L35.5952 16.1173C34.6574 15.4104 33.3441 15.4104 32.4035 16.1159L21.1792 24.5507C20.7429 24.8751 20.3831 25.3469 20.3831 25.8894C20.3831 26.8429 21.2486 28.0399 21.2486 28.0399V41.0832C21.2486 42.6458 22.5194 43.9165 24.082 43.9165H31.1653V33.9999H36.832V43.9165H43.9153C45.4779 43.9165 46.7486 42.6458 46.7486 41.0832V28.0399C46.7486 28.0399 47.6156 26.9774 47.6156 25.8894Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M35.1702 16.6831C34.6871 16.319 34.0624 16.2326 33.5283 16.421C33.2804 16.4394 32.5409 16.8984 32.334 17.0542L22.0235 24.802C21.8521 24.9295 21.0928 25.5046 21.0928 26.1025C21.0928 26.7003 21.9399 27.7798 21.9484 27.7912C21.9513 27.7954 21.9584 41.0837 21.9584 41.0837C21.9584 41.9054 22.4684 42.6081 23.1625 42.8687C23.4104 43.0812 24.6401 43.2087 24.9914 43.2087H30.4584V33.2921H37.5417V43.2087H42.9987C43.3514 43.2087 44.5939 43.0784 44.8418 42.8645C45.5331 42.6038 46.0417 41.9026 46.0417 41.0837V27.7996C46.0445 27.7968 46.0488 27.7954 46.0502 27.7912C46.0573 27.7827 46.8874 26.9072 46.8874 26.1195C46.8874 25.4891 46.0615 24.8657 45.8448 24.7028L35.1702 16.6831Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 26.917V41.0837C22.6666 41.8657 23.3013 42.5003 24.0833 42.5003H29.75V32.5837H38.25V42.5003H43.9166C44.6986 42.5003 45.3333 41.8657 45.3333 41.0837V26.917L34 18.417L22.6666 26.917Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4833 27.6672L34 19.7863L23.5167 27.6658C23.2432 27.8712 22.8551 27.816 22.6482 27.5426L21.9031 26.5509C21.6977 26.2775 21.7529 25.8893 22.0263 25.6839L33.2548 17.2476C33.6954 16.9161 34.3032 16.9161 34.7437 17.2476L45.9722 25.6839C46.2457 25.8893 46.3009 26.2775 46.0955 26.5509L45.3503 27.5426C45.1449 27.8174 44.7567 27.8726 44.4833 27.6672Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_60842",
    x1: 15.9715,
    y1: 13.1342,
    x2: 52.0285,
    y2: 49.1912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D43A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9360C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRAddress);
export default __webpack_public_path__ + "static/media/R_Address.ff9ac1620aaaeea5e085e7a2993e3d38.svg";
export { ForwardRef as ReactComponent };